<div class="modal-header">
  <b class="__title">{{ 'common.createNote' | translate }}</b>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <hr class="simple-separator">
</div>
<div class="modal-body">

  <div class="inner-modal-body">
   
    <section id="view-content">

      <div class="description-container">
        <form [formGroup]="noteForm">
          <div class="form-group"  >
            <textarea class="form-control"
              placeholder="{{ 'common.writeNote' | translate}}" 
              formControlName="note"
              [readonly]="(readOnly)"
              [ngClass]="{
                'is-invalid': !noteForm.get('note').valid && noteForm.get('note').errors?.submitted
              }">
            </textarea>

            <div class="invalid-feedback">
              {{ noteForm.get('note').errors?.message ? 
              noteForm.get('note').errors.message :  
              ("notes.warnings.no-valid" | translate) 
              }}
            </div>
          </div>
        </form>

        <!-- <div class="textarea" *ngIf="readOnly">
          {{ noteForm.get('note')?.value }} ::{{readOnly}}::
        </div> -->
      </div>
      
      <div class="gs">
        <div class="lay lay-lg-40">
          <div class="row-button __actions gs keep-lay" *ngIf="!readOnly">
            <div class="lay-50 p-10-right">
              <button mat-stroked-button class="btn-block" color="primary"
                [disabled]="loading"
                (click)="cancel()">
                <span class="capitalize"> {{ "common.cancel" | translate }} </span>
              </button>
            </div>
            <div class="lay-50 p-10-left">
              <button mat-raised-button class="btn-block" color="primary"
                [disabled]="loading"
                (click)="save(noteForm)">
                <span class="capitalize"> {{ "common.save" | translate }} </span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </section>

  </div>
</div>